<template>
  <div id="business-details-wrapper">
    <p>Reach out to us if you would like to create a new account.</p>
    <p><a href="mailto:hello@evenly.com.au">hello@evenly.com.au</a></p>
  </div>
</template>

<script>
import axios from 'axios'
import api from '@/api.js'

export default {
  name: "BusinessDetails",
  data() {
    return {
      efx_customer: "0",
      loading: false,

      business_name: '',
      business_name_error: null,
      abn: '',
      abn_error: null,
      efx_number: '',
      efx_number_error: null,
      efx_unknown: false ,
      keep_me_posted: true,
      error_message: null,
    };
  },
  computed: {
    button_text(){
      if (this.loading) {
        return "Saving..."
      }
      return "Save and Continue"
    },
    password_length_check() {
      return (this.password.length > 0 && this.password.length < 12)
    }
  },
  methods: {
    check_signup_inputs() {
      let hasError = false;

      // Clear error messages
      this.business_name_error = null;
      this.abn_error = null;
      this.efx_number_error = null;

      // Check inputs
      if (this.business_name == "") {
        this.business_name_error = "This field is required";
        hasError = true;
      }

      if (this.abn == "") {
        this.abn_error = "This field is required";
        hasError = true;
      }

      if (this.efx_number == "" && this.efx_customer == 1 && !this.efx_unknown) {
        this.efx_number_error = "This field is required";
        hasError = true;
      }

      if (!hasError) {
        this.saveBusinessDetails()
      }
    },
    saveBusinessDetails() {
      this.error_message = null;
      this.loading = true;

      const apiRequests = [
        api.post('v2/accounts',
          {
            display_name: this.business_name,
            abn: this.abn,
            equifax_customer_number: this.efx_number,
            jurisdiction: "AU",
            payment_plan: "supplypredict",
          }),

        // this.$store.dispatch("init_account", {
        //   name: this.$store.state.session_info.crisko_user_info.name,
        //   email: this.$store.state.session_info.crisko_user_info.email,
        //   newsletter_optin: this.keep_me_posted
        // })
      ];

      axios.all(apiRequests).then(axios.spread((...responses) => {
        document.location = `/sp?orgId=${responses[0].data.data.account_id}` // Refresh page to use new login details
      })).catch((error) => {
        if (error.response.data.message = 'Bad Request: Invalid abn') {
          this.error_message = 'Invalid ABN, please check!';
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500)
      });
    },
    exit() {
      this.$emit("exit")
    }
  },
};
</script>
<style type="text/css" scoped>
.error_msg {
  color: #000;
  background-color: #FFBABA;
  border: 1px solid;
  padding: 15px;
}
</style>
